import { PrivateAPINamespace } from './PrivateAPINamespace';
export class BreakpointsNamespace extends PrivateAPINamespace {
    get() {
        return this.ps.hostAPI.breakpoints?.get({ id: '213', type: 'DESKTOP' });
    }
}
BreakpointsNamespace.namespace = 'breakpoints';
//# sourceMappingURL=BreakpointsNamespace.js.map